<template>
  <div class="row position-fixed w-100 border-top bottom-actions bg-white">
    <slot name="children"></slot>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ col?: string }>(), { col: "col-10" });
</script>

<style scoped>
.bottom-actions {
  bottom: 0;
  left: 12px;
  z-index: 999;
}
</style>
